<template>
  <van-popup
    :value="value"
    round
    position="center"
    get-container="body"
    class="message-dialog-popup"
    :close-on-click-overlay="closeOnClickOverlay"
    :overlay-style="{ background: 'rgba(0, 0, 0, 0.78)' }"
    @input="$emit('input', $event)"
  >
    <div class="message-dialog" v-if="title || content">
      <div class="message-dialog-header">
        <div class="message-dialog-icon">
          <van-icon name="envelop-o" />
        </div>
        <div class="message-dialog-title">{{ title }}</div>
        <div class="message-dialog-time" v-if="time">{{ time }}</div>
      </div>
      <div class="message-dialog-body">{{ content }}</div>
      <button type="button" class="message-dialog-btn" @click="handleConfirm">
        {{ confirmText }}
      </button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'MessageDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '我知道了',
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="less" scoped>
.message-dialog-popup {
  width: 86%;
  max-width: 640px;
  background: transparent;
  overflow: visible;
}

.message-dialog {
  background: linear-gradient(165deg, #2a2420 0%, #1a1816 55%, #121010 100%);
  border: 2px solid rgba(230, 185, 138, 0.45);
  border-radius: 24px;
  padding: 48px 40px 40px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
  text-align: center;
}

.message-dialog-header {
  margin-bottom: 32px;
}

.message-dialog-icon {
  width: 88px;
  height: 88px;
  margin: 0 auto 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(230, 185, 138, 0.25), rgba(230, 185, 138, 0.08));
  border: 2px solid rgba(230, 185, 138, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;

  .van-icon {
    font-size: 44px;
    color: #e6b98a;
  }
}

.message-dialog-title {
  font-size: 34px;
  font-weight: 600;
  color: #f0d4b0;
  line-height: 1.4;
  word-break: break-word;
}

.message-dialog-time {
  margin-top: 16px;
  font-size: 24px;
  color: rgba(230, 185, 138, 0.55);
}

.message-dialog-body {
  text-align: left;
  max-height: 42vh;
  overflow-y: auto;
  padding: 28px 24px;
  margin-bottom: 36px;
  font-size: 28px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.82);
  white-space: pre-wrap;
  word-break: break-word;
  background: rgba(0, 0, 0, 0.28);
  border-radius: 16px;
  border: 1px solid rgba(230, 185, 138, 0.12);
}

.message-dialog-btn {
  width: 100%;
  height: 88px;
  border: none;
  border-radius: 44px;
  font-size: 30px;
  font-weight: 600;
  color: #1a1208;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  box-shadow: 0 8px 24px rgba(220, 171, 118, 0.35);
  cursor: pointer;

  &:active {
    opacity: 0.88;
    transform: scale(0.98);
  }
}
</style>
